/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TransporteurDto } from '../models/transporteur-dto';
import { TransporteurOrExutoireOrDispatchDto } from '../models/transporteur-or-exutoire-or-dispatch-dto';


/**
 * Fonctions de gestion des transporteurs
 */
@Injectable({
  providedIn: 'root',
})
export class TransporteursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation transporteurGetList
   */
  static readonly TransporteurGetListPath = '/api/transporteurs/list';

  /**
   * Renvoie la liste des transporteurs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TransporteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TransporteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des transporteurs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetList(params?: {
  }): Observable<Array<TransporteurDto>> {

    return this.transporteurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TransporteurDto>>) => r.body as Array<TransporteurDto>)
    );
  }

  /**
   * Path part for operation transporteurGetListActifs
   */
  static readonly TransporteurGetListActifsPath = '/api/transporteurs/list-actifs';

  /**
   * Renvoie la liste des transporteurs actifs et des dispatchs associés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des transporteurs actifs et des dispatchs associés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetListActifs(params?: {
  }): Observable<Array<TransporteurOrExutoireOrDispatchDto>> {

    return this.transporteurGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>) => r.body as Array<TransporteurOrExutoireOrDispatchDto>)
    );
  }

  /**
   * Path part for operation transporteurLoadList
   */
  static readonly TransporteurLoadListPath = '/api/transporteurs/load-list';

  /**
   * Renvoie la liste des transporteurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des transporteurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.transporteurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation transporteurGet
   */
  static readonly TransporteurGetPath = '/api/transporteurs/{id}';

  /**
   * Renvoie le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGet$Response(params: {

    /**
     * Identifiant du transporteur
     */
    id: number;
  }): Observable<StrictHttpResponse<TransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransporteurDto>;
      })
    );
  }

  /**
   * Renvoie le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGet(params: {

    /**
     * Identifiant du transporteur
     */
    id: number;
  }): Observable<TransporteurDto> {

    return this.transporteurGet$Response(params).pipe(
      map((r: StrictHttpResponse<TransporteurDto>) => r.body as TransporteurDto)
    );
  }

  /**
   * Path part for operation transporteurPut
   */
  static readonly TransporteurPutPath = '/api/transporteurs/{id}';

  /**
   * Met à jour le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurPut$Response(params: {

    /**
     * Identifiant du transporteur à mettre à jour
     */
    id: number;

    /**
     * Transporteur
     */
    body: TransporteurDto
  }): Observable<StrictHttpResponse<TransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransporteurDto>;
      })
    );
  }

  /**
   * Met à jour le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurPut(params: {

    /**
     * Identifiant du transporteur à mettre à jour
     */
    id: number;

    /**
     * Transporteur
     */
    body: TransporteurDto
  }): Observable<TransporteurDto> {

    return this.transporteurPut$Response(params).pipe(
      map((r: StrictHttpResponse<TransporteurDto>) => r.body as TransporteurDto)
    );
  }

  /**
   * Path part for operation transporteurDelete
   */
  static readonly TransporteurDeletePath = '/api/transporteurs/{id}';

  /**
   * Supprime le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurDelete$Response(params: {

    /**
     * Identifiant du transporteur à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurDelete(params: {

    /**
     * Identifiant du transporteur à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.transporteurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation transporteurPost
   */
  static readonly TransporteurPostPath = '/api/transporteurs';

  /**
   * Crée le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurPost$Response(params: {

    /**
     * Transporteur
     */
    body: TransporteurDto
  }): Observable<StrictHttpResponse<TransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransporteurDto>;
      })
    );
  }

  /**
   * Crée le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurPost(params: {

    /**
     * Transporteur
     */
    body: TransporteurDto
  }): Observable<TransporteurDto> {

    return this.transporteurPost$Response(params).pipe(
      map((r: StrictHttpResponse<TransporteurDto>) => r.body as TransporteurDto)
    );
  }

  /**
   * Path part for operation transporteurDesactivate
   */
  static readonly TransporteurDesactivatePath = '/api/transporteurs/{id}/desactivate';

  /**
   * Désactive le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurDesactivate$Response(params: {

    /**
     * Identifiant du transporteur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TransporteurDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transporteurDesactivate(params: {

    /**
     * Identifiant du transporteur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TransporteurDto
  }): Observable<number> {

    return this.transporteurDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation transporteurGetByReference
   */
  static readonly TransporteurGetByReferencePath = '/api/transporteurs/reference/{reference}';

  /**
   * Renvoie le transporteur recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transporteurGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<TransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransporteursService.TransporteurGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransporteurDto>;
      })
    );
  }

  /**
   * Renvoie le transporteur recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transporteurGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transporteurGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<TransporteurDto> {

    return this.transporteurGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<TransporteurDto>) => r.body as TransporteurDto)
    );
  }

}
